//
//
//
//
//
//
//
import echarts from 'echarts';
export default {
  props: ['chartData', 'lendName'],
  data: function data() {
    return {
      chart: null
    };
  },
  mounted: function mounted() {
    this.initChart();
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }

    this.chart.dispose();
    this.chart = null;
  },
  watch: {
    chartData: {
      deep: true,
      handler: function handler(val) {
        this.setOptions(val);
      }
    }
  },
  methods: {
    setOptions: function setOptions() {
      this.chart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: "{b} : {c}"
        },
        title: {},
        legend: {
          orient: 'vertical',
          x: 'right',
          left: '75%',
          data: this.lendName,
          width: '50%',
          align: 'left',
          textStyle: {
            fontSize: 12,
            color: 'normal'
          },
          itemHeight: 10,
          itemWidth: 10,
          top: '20',
          selectedMode: false
        },
        color: ['#0050B3', '#1890FF', '#40A9FF', '#69C0FF'],
        series: [{
          type: 'funnel',
          left: '0%',
          top: 100,
          //x2: 80,
          bottom: 60,
          width: '70%',
          // height: {totalHeight} - y - y2,
          min: 0,
          max: 100,
          minSize: '0%',
          maxSize: '100%',
          sort: 'descending',
          gap: 2,
          label: {
            show: true,
            normal: {
              formatter: '{b} : {c}',
              rich: {
                per: {
                  width: '150%'
                }
              }
            },
            position: 'right'
          },
          labelLine: {
            length: 10,
            lineStyle: {
              width: 1,
              type: 'solid'
            }
          },
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 1
          },
          emphasis: {
            label: {
              fontSize: 20
            }
          },
          data: this.chartData
        }]
      });
    },
    initChart: function initChart() {
      console.log(this.chartData);
      this.chart = echarts.init(this.$refs.stageEchart, 'macarons');
      this.setOptions(this.chartData);
    }
  }
};